module.exports = {
  fetch: `query getMedications($queryContext: QueryContextInput) {
    medications(sortBy: "name.en", queryContext: $queryContext, filter: { group: { neq: null }}) {
      id
      key
      name {
        en
        es
      }
      effectChainId
      routes {
        key
        name {
          en
          es
        }
        enabled
        isDefault
        defaultUnits
        defaultAdminTypes
        defaultDosingTypes
        defaultBagVolumes
        defaultFluidColor
        defaultFormularies {
          dose
          dosing
          volume
        }
        defaultPushTimeframes
      }
      group
      description
      dosageForm
      defaultConcentration {
        numeratorValue
        numeratorUnits
        denominatorValue
        denominatorUnits
      }
      defaultAdministeringUnit
    }
  }`,
  fetchById: `query getMedicationById($id: ID!, $queryContext: QueryContextInput) {
    medications(id: $id, queryContext: $queryContext) {
      id
      key
      name {
        en
        es
      }
      description
      effectChain
      effectChainId
      routes {
        key
        name {
          en
          es
        }
        enabled
        isDefault
        defaultUnits
        defaultAdminTypes
        defaultDosingTypes
        defaultBagVolumes
        defaultFluidColor
        defaultFormularies {
          dose
          dosing
          volume
        }
        defaultPushTimeframes
      }
      access {
        read {
          cases
        }
        write {
          cases
        }
      }
      group
      dosageForm
      defaultConcentration {
        numeratorValue
        numeratorUnits
        denominatorValue
        denominatorUnits
      }
      defaultAdministeringUnit
    }
  }`,
  save: `mutation saveMedication($value: MedicationInput, $queryContext: QueryContextInput) {
    upsertMedication(medication: $value, queryContext: $queryContext) {
      id
      key
      name {
        en
        es
      }
      group
      dosageForm
      defaultConcentration {
        numeratorValue
        numeratorUnits
        denominatorValue
        denominatorUnits
      }
    }
  }`,
  add: `mutation addMedication($value: MedicationInput) {
    upsertMedication(medication: $value) {
      id
    }
  }`,
  remove: `
    mutation removeMedications($ids: [ID]) {
      bulkRemoveMedications(ids: $ids)
    }
  `,
};
